import { CacheLocation } from '@auth0/auth0-spa-js'

export const auth0Config = {
  client_id: process.env.REACT_APP_AUTH0_CLIENT_ID || 'eTBcvJ1Ly0IlFS5Rwcpk8lPay4kLL4NZ',
  domain: process.env.REACT_APP_AUTH0_DOMAIN || 'auth.corvum.app',
  cacheLocation: 'localstorage' as CacheLocation
}

export const gtmConfig = {
  containerId: process.env.REACT_APP_GTM_CONTAINER_ID
}
